module.exports = __webpack_public_path__ + "images/people/man-woman-trainers-9fe325fe031ea7fab054fb455632a628.webp";